import { createReducer, on } from '@ngrx/store';
import * as CourseActions from './course.action';
import { Type, CourseContent, CourseContentStructure, CourseStructureNode } from './course.model';
import { state } from '@angular/animations';

export interface CourseState {
  courseType: Type | null;
  courseContent: CourseContent | null;
  structure: CourseContentStructure | null;
}

export const initialState: CourseState = {
  courseType: null,
  courseContent: null,
  structure: {
    data: [],
    course_id: 0
  }
};

export const courseReducer = createReducer(
  initialState,

  on(CourseActions.setCourseType, (state, { courseType }) => ({
    ...state,
    courseType
  })),

  on(CourseActions.resetCourseData, (state) => ({
    ...state,
    courseType: null,
    courseContent: null,
    structure: {
      data: [],
      course_id: 0
    }
  })),

  on(CourseActions.addCourseContent, (state, { content }) => ({
    ...state,
    courseContent: content
  })),

  on(CourseActions.updateCourseContent, (state, { content }) => ({
    ...state,
    courseContent: state.courseContent
      ? { ...state.courseContent, ...content }
      : null
  })),

  // structure 

  on(CourseActions.loadStructure, (state, { course_id }) => ({
    ...state,
    structure: { data: [], course_id: course_id }
  })),

  on(CourseActions.loadStructureSuccess, (state, { structure, course_id }) => ({
    ...state,
    structure: {
      course_id,
      data: structure.map((item): CourseStructureNode => ({
        ...item,
        isEditing: false,
        isOpen: true,
        flag: 0,
        child: (item.child ?? []).map((child): CourseStructureNode => ({
          ...child,
          isEditing: false,
          isOpen: true,
          flag: 0,
          grandChild: (child.grandChild ?? []).map((grand): CourseStructureNode => ({
            ...grand,
            isEditing: false,
            isOpen: true,
            flag: 0,
          }))
        }))
      }))
    }
  })),


  




























);